import { render, staticRenderFns } from "./FormProyecto.vue?vue&type=template&id=1f62027e&"
import script from "./FormProyecto.vue?vue&type=script&lang=js&"
export * from "./FormProyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports